import { UniformatClassificationProperty } from '@deltek/specification-client/core/Models/uniformatClassificationProperty'
import TextField from '@material-ui/core/TextField/TextField'
import React from 'react'

export const AssemblyText = React.memo<{
    elementData?: Partial<UniformatClassificationProperty>
    classes?: any
}>(({ elementData, classes }) => {
    return (
        <TextField
            variant="outlined"
            multiline
            placeholder={elementData?.hint}
            className={classes.assemblyTextField}
            name="ElementPropertiesInput"
            value={elementData?.value}
            inputProps={{
                className: classes.inputText,
                'aria-autocomplete': 'none',
                autoComplete: 'chrome-off',
                maxLength: 500,
            }}
            data-testid="assembliesTextField"
        ></TextField>
    )
})
